import React from 'react';
import './ContactSection.css';

const contactItems = [
  { icon: 'Call', label: 'Phone / WhatsApp', value: '+91 7880 788 799', href: 'tel:+917880788799' },
  { icon: 'Mail', label: 'Email', value: 'support@laftekbusinesssolutions.co.in', href: 'mailto:support@laftekbusinesssolutions.co.in' },
  { icon: 'Time', label: 'Working Hours', value: '9:00 AM - 6:00 PM (Mon-Sat)', href: null },
  { icon: 'Visit', label: 'Address', value: 'Kodi, 7th Floor, BetaBlock, Sigma Soft Tech Park, Whitefield Main Road, Varthur, Bengaluru, Karnataka 560037', href: null },
];

export default function ContactSection() {
  return (
    <section className="contact-section" id="contact">
      <div className="container">
        <div className="contact-header">
          <p className="section-label">Get In Touch</p>
          <h2 className="section-title">Ready to <span>Build Your Career?</span></h2>
          <p className="contact-subtitle">Reach our team for placements, upskilling support, interview guidance, and the next best step for your profile.</p>
        </div>
        <div className="contact-grid">
          <div className="contact-info contact-info-full">
            {contactItems.map((item) => (
              <div key={item.label} className="contact-item">
                <div className="contact-icon">{item.icon}</div>
                <div className="contact-detail">
                  <h4>{item.label}</h4>
                  {item.href ? <a href={item.href}>{item.value}</a> : <p>{item.value}</p>}
                </div>
              </div>
            ))}
            <a href="https://wa.me/917880788799" target="_blank" rel="noreferrer" className="wa-btn">
              Chat on WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
